import { privateRequest } from "../axios";
import type { ApiResponse, ExportFileResult, ListData } from "@/types/common";
import { parseFilenameFromContentDisposition } from "@/lib/downloadExcel";

export interface TicketPayment {
  id: number;
  paymentId: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  eventName: string;
  ticketAmount: number;
  taxAmount: number;
  totalAmount: number;
  paymentType: string | null;
  paymentMethodDetail: string | null;
  paymentStatus: string;
  createdAt: string;
}

export interface TicketPaymentListData extends ListData<TicketPayment> {
  ticketRevenue: number | null;
  totalGstCollected: number | null;
  failedPayments: number | null;
}

export interface GetTicketPaymentsParams {
  pageNo?: number;
  perPage?: number;
  sort?: string;
  paymentStatus?: string | undefined;
  search?: string | undefined;
  eventName?: string | undefined;
  paymentType?: string | undefined;
  eventId?: number | undefined;
  fromDate?: string | undefined;
  toDate?: string | undefined;
}

const ENDPOINTS = {
  TICKET_PAYMENTS: "/payments/tickets",
};

const getAllTicketPayments = async (params: GetTicketPaymentsParams) => {
  const response = await privateRequest.get<ApiResponse<TicketPaymentListData>>(ENDPOINTS.TICKET_PAYMENTS, {
    params,
  });
  return response.data;
};

const exportTicketPayments = async (
  params?: Omit<GetTicketPaymentsParams, "pageNo" | "perPage" | "sort">,
): Promise<ExportFileResult> => {
  const response = await privateRequest.get(ENDPOINTS.TICKET_PAYMENTS, {
    params: { ...params, pageNo: 0, perPage: 1, export: true },
    responseType: "blob",
  });
  return {
    blob: response.data as Blob,
    fileName: parseFilenameFromContentDisposition(response.headers["content-disposition"]),
  };
};

const ticketPaymentService = {
  getAllTicketPayments,
  exportTicketPayments,
};

export default ticketPaymentService;
